import Chat from "@aspen/Store/Aspen/Icons/Chat";
import Issuu from "@aspen/Store/Aspen/Icons/Issuu";
import Linkedin from "@aspen/Store/Aspen/Icons/Linkedin";
import Youtube from "@aspen/Store/Aspen/Icons/Youtube";
import Vimeo from "@aspen/Store/Aspen/Icons/Vimeo";
import AspenLink from "@aspen/Widgets/Basic/AspenLink";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { FC } from "react";

const enum fields {
    title = "title",
    titleLink = "titleLink",
    visibilityState = "visibilityState",
    links = "links"
}

const enum icons {
    youtube = "Youtube",
    issuu = "Issuu",
    linkedin = "Linkedin",
    chat = "Chat",
    vimeo = "Vimeo"
}

const enum visibilityState {
    both = "both",
    label = "label",
    icon = "icon",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.visibilityState]: visibilityState;
    };
}

interface LinkModel {
    fields: {
        title: string;
        icon: string;
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        overriddenTitle: string;
    };
}
const GetIcon = (icon: string): any => {
    switch (icon) {
        case icons.youtube:
            return Youtube;
        case icons.linkedin:
            return Linkedin;
        case icons.issuu:
            return Issuu;
        case icons.chat:
            return Chat;
        case icons.vimeo:
            return Vimeo;
        default:
            break;
    }

    return "";
};

const openChatBox = () => {
    const element = document.getElementsByClassName('mylivechat_buttonround')[0] as HTMLElement;
    element.click();
};

export const AspenSocialLinks: FC<OwnProps> = ({ fields }) => {
    const links = useGetLinks(fields.links, o => o.fields.destination);
    const showIcon = fields.visibilityState === visibilityState.both || fields.visibilityState === visibilityState.icon;
    const showLabel =
        fields.visibilityState === visibilityState.both || fields.visibilityState === visibilityState.label;

    return (
        <ul className="as-social-networks">
            {links.map((link, index) => (
                <li
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                >
                    {link.url && (
                        <AspenLink
                            className="social-link"
                            href={fields.links[index].fields.icon === "Chat" ? '' : link.url}
                            onClick={() => {
                                if (fields.links[index].fields.icon === "Chat") {
                                    openChatBox();
                                }
                            }}
                            target={fields.links[index].fields.openInNewWindow ? "_blank" : ""}
                            icon={{
                                iconProps: {
                                    src: showIcon ? GetIcon(fields.links[index].fields.icon) : undefined,
                                    title: fields.links[index].fields.title,
                                }
                            }}
                        >
                            {showLabel && fields.links[index].fields.title}
                        </AspenLink>
                    )}
                </li>
            ))}
        </ul>
    );
};

const definition: WidgetDefinition = {
    group: "Basic",
    icon: "thumbs-up",
    isSystem: true,
    fieldDefinitions: [
        {
            name: fields.links,
            editorTemplate: "ListField",
            getDisplay: (item: HasFields) => {
                return item.fields.title;
            },
            defaultValue: [],
            fieldType: "Translatable",
            fieldDefinitions: [
                {
                    name: "title",
                    editorTemplate: "TextField",
                    defaultValue: "",
                },
                {
                    name: "icon",
                    displayName: "Select Icon",
                    editorTemplate: "DropDownField",
                    options: [
                        { displayName: "Linkedin", value: icons.linkedin },
                        { displayName: "Youtube", value: icons.youtube },
                        { displayName: "Issuu", value: icons.issuu },
                        { displayName: "Chat", value: icons.chat },
                        { displayName: "Vimeo", value: icons.vimeo },

                    ],
                    defaultValue: "",
                },
                {
                    name: "destination",
                    editorTemplate: "LinkField",
                    defaultValue: {
                        value: "",
                        type: "Url",
                    },
                    isRequired: true,
                    isVisible: item => item.fields.icon !== "Chat",
                },
                {
                    name: "openInNewWindow",
                    editorTemplate: "CheckboxField",
                    defaultValue: false,
                    isVisible: item => item.fields.icon !== "Chat",
                },
            ],
        },
        {
            name: fields.visibilityState,
            displayName: "Visibility",
            editorTemplate: "RadioButtonsField",
            options: [
                {
                    displayName: "Show Both",
                    value: visibilityState.both,
                },
                {
                    displayName: "Show Label Only",
                    value: visibilityState.label,
                },
                {
                    displayName: "Show Icon Only",
                    value: visibilityState.icon,
                },
            ],
            defaultValue: visibilityState.both,
            fieldType: "General",
            sortOrder: 4,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: AspenSocialLinks,
    definition,
};

export default widgetModule;
